import React from 'react';
import { FaClock } from 'react-icons/fa';
import { useExamTimer } from '../hooks/useExamTimer';

/** Exam countdown. Owns the 1 s tick so only this element re-renders every second, not the whole ExamRoom.
 *  When examStopped=true (invigilator stopped the exam) the timer is hidden; everything else stays visible.
 */
const ExamTimerDisplay = React.memo(({ examStarted, examFinished, examEndTime, serverOffset, examStopped }) => {
  const { timeRemaining, formatTime } = useExamTimer(examStarted && !examFinished && !examStopped, examEndTime, serverOffset);

  // Hide timer completely when invigilator has stopped the exam
  if (examStopped) return null;

  return (
    <div className={`exam-timer-display ${timeRemaining < 300 && examStarted ? 'warning' : ''}`}>
      <FaClock />
      {(examStarted && timeRemaining > 0)
        ? formatTime(timeRemaining)
        : (examFinished || (examStarted && examEndTime))
          ? '00:00'
          : '--:--'}
    </div>
  );
});

export default ExamTimerDisplay;